import { ChevronRight } from "lucide-react";
import { OverheadCategoryLibrary } from "@/components/admin/OverheadCategoryLibrary";
import { useSession } from "@/lib/auth-client";

export function OverheadCategoriesPage() {
  const { data: session } = useSession();
  const isAdmin = session?.user?.role === "ops";

  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Operations</span>
          <ChevronRight size={14} />
          <strong>Overhead Categories</strong>
        </div>
      </div>
      <div className="page">
        <div className="page-header">
          <div>
            <h1 className="page-header__title">Overhead Categories</h1>
            <p className="page-header__sub">
              Manage the overhead codes available to engineers in time entry forms.
            </p>
          </div>
        </div>
        <OverheadCategoryLibrary isAdmin={isAdmin} />
      </div>
    </>
  );
}
